import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Icon from "common/components/Icon"
import Menu from "common/components/Menu"
import { useTranslation } from "react-i18next"
import "../../style.scss"

const FacturaHeader = ({
  factura,
  onEdit,
  onDelete,
  handleRedirectToList,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const getOptions = () => {
    return [
      {
        label: `${t("documentos.facturaRec.idView.editLabel")}`,
        icon: "pi pi-pencil",
        command: onEdit,
      },
      {
        label: `${t("documentos.facturaRec.idView.deteleLabel")}`,
        icon: "pi pi-trash",
        className: "card-approval-delete-option",
        command: onDelete,
      },
    ]
  }
  return (
    <div className='factura-recurrente_header tw-items-center'>
      <div className='factura-recurrente_title'>
        <FontAwesomeIcon
          icon={["fal", "arrow-left"]}
          className='icon-plus'
          onClick={handleRedirectToList}
        />
        <p>{t("documentos.facturaRec.idView.title")}</p>
        <span>{factura?.razonSocial}</span>
      </div>
      <Icon>
        <Menu items={getOptions()} />
      </Icon>
    </div>
  )
}

export default FacturaHeader
